import AvailableDaysRadioCards from '../../../../components/KegCollectionForm/AvailableDaysRadioCards'
import CollectionTimesSlider from '../../../../components/KegCollectionForm/CollectionTimesSlider'
import KegLocationRadioCards from '../../../../components/KegCollectionForm/KegLocationRadioCards'
import KegQuantityInputs from '../../../../components/KegCollectionForm/KegQuantityInputs'
import PickupInstructionsTextarea from '../../../../components/KegCollectionForm/PickupInstructionsTextarea'
import {VenueSubmissionFormState, daysOfWeek, KegLocation} from '../../../../types'
import {FetchVenuesResponse as Address} from '../../../../services'

type DayOfWeek = keyof typeof daysOfWeek

interface KegCollectionFormControlProps {
  formValues: VenueSubmissionFormState
  handleKegQuantityInputOnChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleAvailableDaysOnClick: (day: DayOfWeek) => void
  handleTimeRangeOnChange: (value: number[]) => void
  handleKegLocationOnChange: (kegLocation: KegLocation) => void
  handlePickupInstructionsOnChange: (instructions: string) => void
  flagFormErrors: boolean
  chosenLocation?: Address | null
}

export default function KegCollectionFormControl(props: KegCollectionFormControlProps) {
  const {
    formValues,
    handleKegQuantityInputOnChange,
    handleAvailableDaysOnClick,
    handleTimeRangeOnChange,
    handleKegLocationOnChange,
    handlePickupInstructionsOnChange,
    flagFormErrors,
    chosenLocation,
  } = props
  return (
    <div className="mt-5">
      <h2 className="text-slate-500 dark:text-slate-300 text-lg font-semibold text-center mb-8">
        Keg Collection Request Details
      </h2>

      <KegQuantityInputs
        formValues={{
          '20L': formValues.collectionRequest['20L'],
          '30L': formValues.collectionRequest['30L'],
          '50L': formValues.collectionRequest['50L'],
          '9G': formValues.collectionRequest['9G'],
        }}
        onChange={handleKegQuantityInputOnChange}
        isDisabled={false}
        inputRef={null}
        flagFormErrors={flagFormErrors}
        chosenLocation={chosenLocation}
      />

      <AvailableDaysRadioCards
        handleOnClick={(day: DayOfWeek) => handleAvailableDaysOnClick(day)}
        collectionDays={[
          ...(formValues.collectionRequest.venueOpenMonday ? ['Monday' as DayOfWeek] : []),
          ...(formValues.collectionRequest.venueOpenTuesday ? ['Tuesday' as DayOfWeek] : []),
          ...(formValues.collectionRequest.venueOpenWednesday ? ['Wednesday' as DayOfWeek] : []),
          ...(formValues.collectionRequest.venueOpenThursday ? ['Thursday' as DayOfWeek] : []),
          ...(formValues.collectionRequest.venueOpenFriday ? ['Friday' as DayOfWeek] : []),
        ]}
        flagFormErrors={flagFormErrors}
        chosenLocation={chosenLocation}
      />

      <CollectionTimesSlider
        sliderTimeRange={[
          formValues.collectionRequest.startHour,
          formValues.collectionRequest.endHour,
        ]}
        onChange={handleTimeRangeOnChange}
      />

      <KegLocationRadioCards
        onClick={handleKegLocationOnChange}
        kegLocation={formValues.collectionRequest.kegLocation}
      />

      <PickupInstructionsTextarea
        value={formValues.collectionRequest.pickupInstructions}
        onChange={handlePickupInstructionsOnChange}
        isDisabled={false}
      />
    </div>
  )
}
